import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import { STORE_ROUTER } from '../../../constants';
import { RouterStore } from '../../../stores';

export interface GoBackProps extends RouteComponentProps<{}> {
  fallback?: string;
}

export interface GoBackState {
  /* empty */
}

@inject(STORE_ROUTER)
@observer
export class GoBack extends React.Component<GoBackProps, GoBackState> {
  UNSAFE_componentWillMount() {
    const routerStore = this.props[STORE_ROUTER] as RouterStore;

    if (routerStore.locationHistory.length > 1) {
      // If we have previous routes within the application to go back to, then do that
      this.props.history.goBack();
    } else {
      // Else just replace current URL with our fallback route
      this.props.history.replace(this.props.fallback || '/');
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Utils/GoBack/index.tsx